<!--校园安全-政策-->
<template>
    <div class="studio_nav_content">
        <!--首页：国家层面/山西省层面/学校安全相关标准目录-->
        <div class="home-container" v-show="showMode==='page'">
            <!--分类Tab：政策/视频（切换到视频由父级处理）-->
            <div class="sp-cat-tabs">
                <div class="sp-cat-tab" @click="$emit('change-tab', 'video')">视频</div>
                <div class="sp-cat-tab sp-cat-tab-active">政策</div>
                
            </div>
            <div class="section-card" v-for="sec in sections" :key="sec.category">
                <div class="title-container">
                    <a class="a-link">{{ sec.title }}</a>
                    <a class="more-link" @click="pageMore(sec)">更多</a>
                </div>
                <div class="item-container">
                    <div class="item-one" v-for="item in homeData[sec.key]" :key="item.zhengcId">
                        <div class="dj-item-l"><div class="dj-yuan"></div></div>
                        <div class="dj-item-r" @click="viewZhengc(item, 'page')">{{ item.title }}</div>
                    </div>
                    <div class="div-100" v-if="!homeData[sec.key] || homeData[sec.key].length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
        </div>

        <!--更多列表-->
        <div class="page-mode" v-show="showMode==='list'">
            <div class="head-container">
                <div class="left-head-container" @click="backHome">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{ title }}</div>
                <div class="left-head-container">
                    <el-form-item class="pull-right">
                        <el-input v-model="queryParams.title" placeholder="请输入名称搜索" class="input-with-select"
                                  clearable @clear="pageList">
                            <template #append>
                                <el-button type="primary" @click="pageList" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                            </template>
                        </el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="right-container">
                <div class="info-list-container">
                    <div class="more-item" v-for="item in dataList" :key="item.zhengcId">
                        <div class="more-yuan"></div>
                        <div class="more-item-l" @click="viewZhengc(item, 'list')">{{ item.title }}</div>
                        <div class="more-item-r">{{ timestampDate(item.createTime) }}</div>
                    </div>
                    <data-empty v-if="dataList && dataList.length===0" title="暂无数据"/>
                </div>
                <div class="page-container" v-if="dataList && dataList.length>0">
                    <pageTag :background="true"
                             :pageSizes="[10, 20, 30]"
                             v-show="total > 0"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageList" />
                </div>
            </div>
        </div>

        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detail'">
            <zhengc-info :zhengc-id="this.zhengcId"
                         @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import zhengcInfo from "@/components/resourceCentre/zhengcInfo.vue";
import {timestampDate} from "@/utils/date";
import {homeSchoolSafe, pageZhengc} from "@/api/admin/zhengc";

export default {
    name: 'schoolSafePolicy',
    components: {dataEmpty, pageTag, zhengcInfo},
    props: {
        courseMode: {
            type: String,
            default: 'page'
        },
    },
    watch: {
        courseMode(newValue, oldValue) {
            if (newValue === 'page') {
                this.showMode = 'page';
            }
        },
    },
    data() {
        return {
            showMode: 'page',
            timestampDate,
            homeData: {},
            /*三个模块：key为首页聚合数据字段，category为分页查询类别*/
            sections: [
                {title: '国家层面', key: 'gjcmList', category: '1'},
                {title: '山西省层面', key: 'sxcmList', category: '2'},
                {title: '学校安全相关标准目录', key: 'xxcmList', category: '3'},
            ],
            title: '',
            queryParams: {
                zhengcType: 2,
                category: '',
                title: '',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            dataList: [],
            zhengcId: '',
            /*进入详情的来源：page-首页 list-更多列表*/
            fromMode: 'page',
        }
    },
    created() {
        this.queryHomeData();
    },
    methods: {
        // 首页聚合数据
        queryHomeData() {
            homeSchoolSafe({zhengcType: 2}).then(res => {
                if (res.data.code === 1) {
                    this.homeData = res.data.data;
                } else {
                    this.$message.error("请求出错")
                }
            })
        },
        // 更多
        pageMore(sec) {
            this.title = sec.title;
            this.queryParams.category = sec.category;
            this.queryParams.title = '';
            this.queryParams.pageNum = 1;
            this.showMode = 'list';
            this.$emit('change-mode', 'detail');
            this.pageList();
        },
        // 分页查询
        pageList() {
            pageZhengc(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                } else {
                    this.$message.error("请求出错")
                }
            })
        },
        // 查看详情
        viewZhengc(item, from) {
            this.fromMode = from;
            this.zhengcId = item.zhengcId;
            this.showMode = "detail";
            this.$emit('change-mode', 'detail');
        },
        // 详情返回
        changeModel() {
            this.showMode = this.fromMode;
            this.$emit('change-mode', this.fromMode === 'page' ? 'page' : 'detail');
        },
        // 更多列表返回首页
        backHome() {
            this.showMode = 'page';
            this.$emit('change-mode', 'page');
        },
    }
}
</script>

<style lang="scss" scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.home-container{
    width: 100%;
    height: auto;
}
/*分类Tab：政策/视频，带边框，选中加底色*/
.sp-cat-tabs{
    display: flex;
    gap: 10px;
    margin-bottom: 14px;
}
.sp-cat-tab{
    font-size: 15px;
    color: #17365d;
    cursor: pointer;
    padding: 4px 22px;
    border: 1px solid #b9cfe8;
    border-radius: 17px;
    background: #ffffff;
    white-space: nowrap;
    transition: all .15s ease;
}
.sp-cat-tab:hover{
    border-color: #0d55a4;
    color: #0d55a4;
}
.sp-cat-tab-active{
    background: #0d55a4;
    border-color: #0d55a4;
    color: #ffffff;
}
.sp-cat-tab-active:hover{
    color: #ffffff;
}
/*板块白色卡片，内容超出时页面自然滚动*/
.section-card{
    background: #ffffff;
    border-radius: 16px;
    padding: 18px 24px 12px;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.title-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #e3ecf7;
    margin-bottom: 12px;
}
.a-link{
    font-size: 18px;
    color: #0d55a4;
    font-weight: bold;
    border-bottom: 2px solid #0d55a4;
    padding-bottom: 8px;
    margin-bottom: -1px;
    text-decoration: none;
}
.more-link{
    font-size: 15px;
    color: #8a97a8;
    padding-bottom: 8px;
    text-decoration: none;
    cursor: pointer;
}
.more-link:hover{
    color: #0d55a4;
}
/*条目三列布局*/
.item-container{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.item-one{
    width: 33.33%;
    display: flex;
    box-sizing: border-box;
    padding-right: 16px;
}
.dj-item-l{
    width: 12px;
    height: 40px;
    flex-shrink: 0;
}
.dj-yuan{
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #0d55a4;
    margin-top: 12px;
}
.dj-item-r{
    width: calc(100% - 12px);
    height: 40px;
    color: #595758;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    padding-top: 3px;
    box-sizing: border-box;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.dj-item-r:hover{
    color: #0d55a4;
}
.div-100{
    width: 100%;
}
/*更多列表（样式参考党建引领-更多）*/
.page-mode{
    width: 100%;
    height: calc(100vh - 174px);
    background-color: #fff;
    border-radius: 16px;
    padding: 10px 28px 10px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.head-container{
    flex-shrink: 0;
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
/deep/ .el-form-item{
    margin-bottom: 0;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.right-container{
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}
.info-list-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.more-item{
    width: 100%;
    height: 40px;
    display: flex;
    border-bottom: 1px dashed #eef2f7;
}
.more-item-l{
    width: calc(100% - 100px);
    height: 40px;
    color: #434343;
    line-height: 40px;
    font-size: 15px;
    padding-left: 8px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.more-item-l:hover{
    color: #0d55a4!important;
}
.more-item-r{
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #999999;
    text-align: right;
    flex-shrink: 0;
}
.more-yuan{
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #0d55a4;
    margin-top: 17px;
    flex-shrink: 0;
}
.page-container{
    flex-shrink: 0;
    display: grid;
    place-items: center;
    width: 100%;
    padding-top: 12px;
    box-sizing: border-box;
}
/*详情模式：白色卡片，内容在卡片内滚动*/
.detail-mode{
    width: 100%;
    height: calc(100vh - 174px);
    overflow-y: auto;
    background: #ffffff;
    border-radius: 16px;
    padding: 10px;
    box-sizing: border-box;
}
</style>
